import React from 'react';
import { PlayIcon } from 'lucide-react';
interface PhoneFrameProps {
  label?: string;
  hint?: string;
  videoSrc?: string;
  className?: string;
}

/**
 * Marco de iPhone vertical listo para insertar un video MP4/GIF o una captura.
 */
export function PhoneFrame({
  label = 'Espacio para video vertical',
  hint = 'MP4 o GIF · formato 9:16',
  videoSrc,
  className = ''
}: PhoneFrameProps) {
  return <div className={`relative mx-auto w-full max-w-[220px] rounded-[2rem] border border-neon/30 bg-ink-900 p-2 shadow-glow ${className}`} data-id="element-181" data-mp="27kqvufbfp08j">
      <div className="relative aspect-[9/19] overflow-hidden rounded-[1.6rem] border border-white/5 bg-ink-800" data-id="element-182" data-mp="2bnnkonrkhskx">
        <div aria-hidden="true" className="absolute left-1/2 top-2 z-10 h-1.5 w-14 -translate-x-1/2 rounded-full bg-black/60" data-id="element-183" data-mp="2ljqlnqaonl6a" />
        {videoSrc ? <video src={videoSrc} autoPlay muted loop playsInline className="h-full w-full object-cover" data-id="element-184" data-mp="m8qwkxylbbda" /> : <div className="flex h-full flex-col items-center justify-center gap-3 px-5 text-center" data-id="element-185" data-mp="38yunijb2ehq5">
            <span className="grid h-11 w-11 place-items-center rounded-full border border-neon/50 bg-neon/10 text-neon" data-id="element-186" data-mp="343yhugcwnvuk">
              <PlayIcon className="h-4 w-4" aria-hidden="true" data-id="element-187" data-mp="2v5czombciiub" />
            </span>
            <span className="text-xs font-medium text-mist" data-id="element-188" data-mp="2v3jsn5wtlwls">{label}</span>
            <span className="text-[10px] leading-relaxed text-mist-dim" data-id="element-189" data-mp="3rv3z8zyhuw6z">{hint}</span>
          </div>}
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-neon/10 to-transparent" data-id="element-190" data-mp="3mxc8i99l5g4d" />
      </div>
    </div>;
}